export enum ListViewTypes {
  PROPERTY_ADDRESS = 'propertyAddress',
  LAST_ORDER = 'lastOrder',
  AGE_OF_PHOTOS = 'ageOfPhotos',
  PROPERTY_STATUS = 'propertyStatus',
  DEFAULT = 'default',
  TOTAL = 'total',
  ORDER_ID = 'orderId',
  DESCRIPTION = 'description'
}

// `lastOrder` and `orderDate` flow into ListViewCell.tsx where they're used as
// ReactNode and a numeric epoch. Tightening to those shapes cascades into the
// property-list pipeline; banked Pass 14 for follow-up.
/* eslint-disable @typescript-eslint/no-explicit-any */
export type ListViewCellConfiguration = {
  type: ListViewTypes;
  address?: string;
  age?: number | null;
  lastOrder?: any | null;
  propertyStatus?: string;
  total?: string;
  orderId?: string;
  orderDate?: any;
  isOrderConfirm?: boolean;
  description?: string;
};
